import React from 'react';

import { loadGraphQLData } from '../page';
import VWAContainer from './vwa-container';
import BeHPTracker from './components/behp-tracker';

const VWA = props => {
    return (
        <>
            <VWAContainer {...props} />
            <BeHPTracker />
        </>
    );
};

export default {
    component: VWA,
    loadData: loadGraphQLData,
};
